import React from "react";
import Layout from "../../Layout";
import TeamDetails from "../../containers/TeamDetails";

export default function TeamDetailsPage() {
  return (
    <Layout>
      <TeamDetails />
    </Layout>
  );
}
